/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Order History functionality
define('modules/User/OrderHistory',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Cart/all'
], function ($, _, Roc, Cart) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var pagination;
    var viewModel = {};
    var isImpersonationActive = false;
    var btns = {
        reOrder: '[data-roc-action="reOrder"]',
        viewOrderDetails: '[data-roc-action="viewDetails"]',
        approvePendingOrder: '[data-roc-action="approveOrder"]',
        deletePendingOrder: '[data-roc-action="deleteOrder"]' // custom action available only for corporate masters
    };

    function reOrderEvt() {
        $(document).on('click', btns.reOrder, function () {
            var orderId = Roc.UI.getItemId(this);
            Roc.UI.confirm({
                "title": 'Edit Order',
                "message": 'Do you want your cart to be replaced with the available item(s)?',
                "buttons": {
                    "Continue": {
                        "class": 'btn btnAction re-order',
                        "autoClose": false,
                        "action": function () {
                            Cart.CartManager.reOrder(orderId, {
                                beforeSend: function () {
                                    Roc.Core.lockButton('.btn.btnAction.re-order');
                                }
                            });
                        }
                    },
                    "Cancel": {
                        "class": 'btn',
                        "action": function () { }
                    }
                }
            });
        });

        function filterOutMessagesForDisplay(response) {
            var errors = 0;
            if (response.messages > 0) {
                _.each(response.addCartItemsResponse, function (response) {
                    response.errors = response.errors || [];
                    //Customization to display all error messages rather than filter them out
                    //response.errors = _.filter(response.errors, function (e) {
                    //    return e.errorMessage !== 'Sorry, this item is no longer available.';
                    //});

                    errors += response.errors.length;
                });
                response.messages = errors;
            }
            return errors === 0;
        }

        Roc.EventManager.bind(Roc.Events.cart.RE_ORDER, function (xhr) {
            var response = xhr.responseJSON || {};
            var redirectToCart = response.orderId && filterOutMessagesForDisplay(response);
            if (redirectToCart) {
                window.location.href = '/cart';
            } else {
                if (response.messages > 0) {
                    var model = {};

                    model.heading = response.cart ? 'Your cart have been loaded with problems:' :
                        'Problems occurred during your request and we were not able to load your cart.';
                    model.responses = response.addCartItemsResponse;

                    Roc.UI.template('serviceErrors-Tmp', model).then(function (renderedTemplate) {
                        $('#confirmBox').html(renderedTemplate);
                    });

                    $('#confirmButtons .btn.btnAction.re-order').remove();
                    $('#confirmButtons .btn').text('Continue');
                } else {
                    Roc.UI.ajaxErrorPopup(xhr, response.message);
                    Roc.Core.releaseLockedButton('.btn.btnAction.re-order');
                }
            }
        });
    }

    function openOrderDetailsEvt() {
        $(document).on('click', btns.viewOrderDetails, function () {

            var orderId = Roc.UI.getItemId(this);
            var targetSelector = $(this).attr('href');

            if ($.trim($(targetSelector).text()).length === 0) {
                $.ajax({
                    url: apiUrl + '/api/order/' + orderId + '/',
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json',
                    beforeSend: function () {
                        Roc.UI.block(targetSelector);
                    },
                    complete: function (xhr) {
                        Roc.Logger.info('OrderHistory -> openOrderDetailsEvt');
                        Roc.Logger.info(xhr);
                        var response = xhr.responseJSON || {};

                        if (xhr.status === 200) {
                            // Customization: calculate order items margin value
                            response.isImpersonationActive = isImpersonationActive
                            if (isImpersonationActive) {
                                Roc.OrderHelper.setOrderMargins(response);
                            }
                            // Customization: extract productSFSNumber from custom fields to display 
                            _.forEach(response.recipients,
                                function (r) {
                                    //Customization: copy PO flag to recipients
                                    r.isPurchaseOrder =
                                        response && response.customFields && response.customFields.isPurchaseOrder;

                                    _.forEach(r.items,
                                        function (item) {
                                            Roc.ProductHelper.setProductSFSNumber(item);
                                        });
                                });
                            //Customization: Copy Organization Address from Order Summary View Model to Order Details
                            var orderSummary = _.find(viewModel.orders, function (order) { return order.orderId == orderId; });
                            if (orderSummary && orderSummary.organizationAddress) {
                                response.billingAddress = orderSummary.organizationAddress;
                            }
                            // End
                            Roc.UI.template('orderDetails-Tmp', response).then(function (renderedTemplate) {
                                $(targetSelector).html(renderedTemplate);
                            });
                        } else {
                            Roc.UI.Modal.alert('Failed to load order details');
                        }

                        Roc.UI.unblock(targetSelector);
                    }
                });
            }
            return false;
        });
    }
    // Customization: Corporate masters are allowed to delete pending orders 
    function deletePendingOrderEvt() {

        $(document)
            .off('click', btns.deletePendingOrder)
            .on('click', btns.deletePendingOrder, function () {
                var itemId = Roc.UI.getItemId(this, 'item-id');
                var btnDelete = this;
                Roc.UI.confirm('Are you sure you want to remove this pending order?', function () {
                    deletePendingOrder(btnDelete, itemId);
                });
            });
    }

    function approvePendingOrderEvt() {
        $(document).on('click', btns.approvePendingOrder, function () {
            var orderId = Roc.UI.getItemId(this);
            var btnApprove = this;
            Roc.Core.lockButton(btnApprove);
            $.ajax({
                url: apiUrl + '/api/order/' + orderId + '/approve/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(Roc.UI.getItemId(this)),
                complete: function (xhr) {
                    Roc.Logger.info('OrderHistory -> approvePendingOrderEvt');
                    Roc.Logger.info(xhr);
                    if (xhr.status === 200) {
                        $('[data-id="' + orderId + '"] .status-label').text('Ordered');
                        $(btnApprove).remove();
                        Roc.UI.success('Completed!');
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                        Roc.Core.releaseLockedButton(btnApprove);
                    }
                }
            });

            return false;
        });
    }

    function deletePendingOrder(btnDelete, orderId) {
        Roc.Core.lockButton(btnDelete);

        return $.ajax({
            url: apiUrl + '/api/hierarchicalorganization/pending-order/' + orderId,
            type: 'DELETE',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            complete: function (xhr) {
                Roc.Logger.info('OrderHistory -> deletePendingOrderEvt');
                Roc.Logger.info(xhr);
                if (xhr.status === 200) {
                    $('[data-id="' + orderId + '"]').remove();
                    Roc.UI.success('Removed!');
                } else {
                    Roc.UI.ajaxErrorPopup(xhr);
                    Roc.Core.releaseLockedButton(btnDelete);
                }
            }
        });
    }

    function bindEvents() {
        openOrderDetailsEvt();
        reOrderEvt();
        approvePendingOrderEvt();
        deletePendingOrderEvt();
    }

    function loadOrders(data) {
        // Customization: copy organization address from custom field to property
        setOrganizationAddress(data.orders);
        // End 
        Roc.UI.template('orderHistory-Tmp', data).then(function (renderedTemplate) {
            $('#order-history').replaceWith(renderedTemplate);
        });

        if (data.orders.length > 0) {
            Roc.UI.template('pager-Tmp', data.pagination).then(function (renderedTemplate) {
                $('#order-history').prepend(renderedTemplate);
            });
            pagination = Roc.Pagination.updatePaging(data);
        }
    }

    function reloadWidget(pg) {
        pg = pg || pagination;

        $.ajax({
            url: apiUrl + '/api/order/history/model/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(pg),
            complete: function (xhr) {
                Roc.Logger.info('OrderHistory -> reloadWidget');
                Roc.Logger.info(xhr);
                if (xhr.status === 200) {
                    var response = xhr.responseJSON || {}
                    loadOrders(response);
                } else {
                    Roc.UI.ajaxErrorPopup(xhr);
                }
            }
        });
    }

    // Customization: copy organization address from custom field to property
    function setOrganizationAddress(orders) {
        _.each(orders,
            function (order) {
                if (order.customFields && order.customFields.organizationAddress) {
                    order.organizationAddress = order.customFields.organizationAddress;
                }
            });
    }
    // End 
    function init(model, impersonationActive, isCorporateMaster) {
        isCorporateMaster = isCorporateMaster || false;
        isImpersonationActive = impersonationActive;
        viewModel = model;
        viewModel.canDeleteOrders = isCorporateMaster;
        viewModel.emptyResultsSelector = '#noOrdersMsg';
        viewModel.orderListSelector = '#order-history';

        if (viewModel.pagination) {
            pagination = Roc.Pagination.init({
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.pageSize,
                totalPages: viewModel.pagination.totalPages,
                prefix: '#order-history-wrapper'
            }, reloadWidget);
        }
        loadOrders(viewModel);
        bindEvents();
    };

    var OrderHistory = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderHistory.js Loaded:', OrderHistory);

    return OrderHistory;
});
